var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F56A50"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6095 21.7235C23.0888 21.2028 22.2446 21.2028 21.7239 21.7235C21.2032 22.2442 21.2032 23.0885 21.7239 23.6092L30.1144 31.9997L21.7239 40.3902C21.2032 40.9109 21.2032 41.7551 21.7239 42.2758C22.2446 42.7965 23.0888 42.7965 23.6095 42.2758L32 33.8853L40.3906 42.2758C40.9112 42.7965 41.7555 42.7965 42.2762 42.2758C42.7969 41.7551 42.7969 40.9109 42.2762 40.3902L33.8857 31.9997L42.2762 23.6092C42.7969 23.0885 42.7969 22.2442 42.2762 21.7235C41.7555 21.2028 40.9112 21.2028 40.3905 21.7235L32 30.1141L23.6095 21.7235Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.8d2897b6c50e26ac14c1ed31273a9593.svg";
export { ForwardRef as ReactComponent };